// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
import {RECOMMENDED_MODELS, type RecommendedModelCategory} from '@github-ui/copilot-chat/utils/recommended-chat-models'

import {type ModelPickerItem, type ModelPickerItemGroup, ModelPickerManufacturer} from './ModelPickerV2.types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IS_STORYBOOK = (import.meta as any)?.env?.STORYBOOK === 'true'

export const MANUFACTURER_ICONS: Record<ModelPickerManufacturer, string> = {
  OpenAI: `${IS_STORYBOOK ? 'https://github.com' : ''}/images/modules/marketplace/models/families/openai-logo.svg`,
  Anthropic: `${IS_STORYBOOK ? 'https://github.com' : ''}/images/modules/marketplace/models/families/anthropic.svg`,
  Google: `${IS_STORYBOOK ? 'https://github.com' : ''}/images/modules/marketplace/models/families/gemini.svg`,
  xAI: `${IS_STORYBOOK ? 'https://github.com' : ''}/images/modules/marketplace/models/families/xai.svg`,
}

export const COPY = {
  heading: 'Models',
  preview: 'Preview',
  signInCta: {
    label: 'Sign in',
    description: 'Sign in or create an account to explore available models',
  },
}

const CATEGORY_GROUP_LABELS: Record<RecommendedModelCategory, string> = {
  lightweight: 'Fast and cost-efficient',
  versatile: 'Versatile and highly intelligent',
  powerful: 'Most powerful at complex tasks',
}

const CATEGORY_ORDER: RecommendedModelCategory[] = ['lightweight', 'versatile', 'powerful']

// Derive MODEL_PICKER_DATA from the shared RECOMMENDED_MODELS config so tier
// assignments, labels, and order stay in sync with the logged-in picker.
// isFree marks models available to logged-out/free users (no requiredPlan).
// Models flagged `upsellable: false` are excluded
export const MODEL_PICKER_DATA: ModelPickerItemGroup[] = CATEGORY_ORDER.map(category => ({
  groupLabel: CATEGORY_GROUP_LABELS[category],
  items: RECOMMENDED_MODELS.filter(e => e.category === category && e.upsellable).map(
    (e): ModelPickerItem => ({
      id: e.id,
      label: e.displayName,
      manufacturer: e.vendor as ModelPickerManufacturer,
      isFree: !e.requiredPlan,
    }),
  ),
}))
